import { useCallback, useMemo, useRef } from 'react';

export const useActiveSourceRefs = () => {
  const activeSourceRefsRef = useRef<string[]>([]);
  // sourceRef → 소스 타입('file' | 'youtube' | 'website') — 분석(turn_start의
  // has_*_source)용. consume 후에도 재사용(retry)될 수 있어 세션 clear 까지 유지한다.
  const sourceTypeByRefRef = useRef<Record<string, string>>({});

  const clear = useCallback(() => {
    activeSourceRefsRef.current = [];
    sourceTypeByRefRef.current = {};
  }, []);

  const consume = useCallback(() => {
    const sourceRefs = activeSourceRefsRef.current;
    activeSourceRefsRef.current = [];
    return sourceRefs;
  }, []);

  const markActive = useCallback((sourceRef: string) => {
    activeSourceRefsRef.current = activeSourceRefsRef.current.includes(
      sourceRef,
    )
      ? activeSourceRefsRef.current
      : [...activeSourceRefsRef.current, sourceRef];
  }, []);

  const recordSourceType = useCallback(
    (sourceRef: string, sourceType: string) => {
      sourceTypeByRefRef.current = {
        ...sourceTypeByRefRef.current,
        [sourceRef]: sourceType,
      };
    },
    [],
  );

  const getSourceTypes = useCallback(
    (sourceRefs: string[]) =>
      sourceRefs
        .map(sourceRef => sourceTypeByRefRef.current[sourceRef])
        .filter((sourceType): sourceType is string => Boolean(sourceType)),
    [],
  );

  return useMemo(
    () => ({
      clear,
      consume,
      markActive,
      recordSourceType,
      getSourceTypes,
    }),
    [clear, consume, markActive, recordSourceType, getSourceTypes],
  );
};
